"use strict";
// @ts-ignore
try {
    self['workbox:expiration:5.1.4'] && _();
}
catch (e) { }
